export let currentPropertiesPanelItemOfViewer: string = '';

/* Updates the Currently Shown Item and resets the temporary Save Elements*/
export function updateCurrentPropertiesPanelItemForViewer(newId: string) {
    if (currentPropertiesPanelItemOfViewer !== newId) {
        currentPropertiesPanelItemOfViewer = newId;
    }
}
